import apiReq from '../commontools/api.js'
export function GetBookTypeValid(){
	var url='/Book/GetBookTypeValid';
	return apiReq.get(url);
}
export function GetBookTypeAll(){
	var url='/Book/GetAllBookType';
	return apiReq.get(url);
}
export function AddBookType(info){
	var url='/Book/AddBookType';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function EditBookType(info){
	var url='/Book/EditBookType';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function AddBranchBookType(info){
	var url='/Book/AddBranchBookType';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function EditBranchBookType(info){
	var url='/Book/EditBranchBookType';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function DelBranchBookType(branchid,booktypeid){
	var url='/Book/DelBranchBookType/'+branchid+'/'+booktypeid;
	return apiReq.get(url);
}
export function GetBranchBookType(branchid){
	var url='/Book/GetBranchBookType/'+branchid;
	return apiReq.get(url);
}
export function SaveBranchBookCapacity(branchid,datestart,dateend){
	var url='/Book/SaveBranchBookCapacity/'+branchid+'/'+datestart+'/'+dateend;
	return apiReq.get(url);
}
export function GetBranchBookCapacity(branchid,datestart,dateend){
	var url='/Book/GetBranchBookCapacity/'+branchid+'/'+datestart+'/'+dateend;
	return apiReq.get(url);
}
export function EditBranchBookCapacity(info){
	var url='/Book/EditBranchBookCapacity';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function GetBranchBookCapacityUsed(branchid,datestart,dateend){
	var url='/Book/GetBranchBookCapacityUsed/'+branchid+'/'+datestart+'/'+dateend;
	return apiReq.get(url);
}
export function CancelBookDetail(bookid){
	var url='/Book/CancelBookDetail/'+bookid;
	return apiReq.get(url);
}
export function AddBookDetail(info){
	var url='/Book/AddBookDetail';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function GetBookDetailByJson(info){
	
	var url='/Book/GetBookDetailByJson';
	var p={
		data:info
	}
	return apiReq.post(url,p);
}
export function StatBookNumByOrderID(corpid,orderid){
	var url='/Book/StatBookNumByOrderID/'+corpid+'/'+orderid;
	return apiReq.get(url);
}
export function GetBranchBookedDetailByBookDate(branchid,datestart,dateend){
	var url='/Book/GetBranchBookedDetailByBookDate/'+branchid+'/'+datestart+'/'+dateend;
	return apiReq.get(url);
}
export default{
	GetBookTypeValid,
	GetBookTypeAll,
	AddBookType,
	EditBookType,
	GetBranchBookType,
	AddBranchBookType,
	EditBranchBookType,
	DelBranchBookType,
	SaveBranchBookCapacity,
	GetBranchBookCapacity,
	EditBranchBookCapacity,
	GetBranchBookCapacityUsed,
	CancelBookDetail,
	AddBookDetail,
	GetBookDetailByJson,
	StatBookNumByOrderID,
	GetBranchBookedDetailByBookDate
}